import { createProdMockServer } from 'vite-plugin-mock/es/createProdMockServer';

const mockModules:Array<any> = [];
const mockContext = import.meta.globEager('./mock/**/*.ts'); // 相对该文件的路径
Object.keys(mockContext).forEach(v =>
{
    mockModules.push(...mockContext[v].default);
});

/**
 * 用于生产环境
 */
export function setupProdMockServer()
{
    createProdMockServer(mockModules); // vite-mock插件是通过module中的url来做路由匹配
}
